import { createAction, createSlice } from "@reduxjs/toolkit";

const exploreCourseSlice = createSlice({
  name: "exploreCourse",
  initialState: { data: null, pagination: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data, pagination } = action.payload;
      state.data = data.data;
      state.pagination = pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    updateStatus(state, action) {
      const [id, status] = action.payload.data;
      state.data = state.data?.map((course) =>
        course.id === id ? { ...course, status } : course
      );
    },

    // delete saved course
    updateSaveStatus(state, action) {
      if (state.data) {
        const courses = [...state.data];
        const courseIndex = courses.findIndex(
          (course) => course.id === action.payload.courseId
        );
        if (courseIndex !== -1) {
          const courseUpdated = {
            ...courses[courseIndex],
            isSave: action.payload.isSave,
          };
          state.data = [
            ...courses.slice(0, courseIndex),
            courseUpdated,
            ...courses.slice(courseIndex + 1),
          ];
        }
      }
    },
    updateSaveStatusAll(state, action) {
      const courses = [...state.data].map((course) => ({
        ...course,
        isSave: action.payload.isSave,
      }));
      state.data = courses;
    },
  },
});

const { name, actions, reducer } = exploreCourseSlice;
const exploreCourseAction = createAction(name);
const updateCourseStatusAction = actions.updateStatus;

export {
  exploreCourseAction,
  updateCourseStatusAction,
  actions as exploreCourseActions,
  reducer as exploreCourseReducer,
};
